import { Helmet } from "react-helmet-async";

export default function SEO({
  title = "UX/UI Designer Freelance | Web Designer | React Developer | Pavia, Milano e Italia",

  description =
    "UX/UI Designer e Front-End React Developer freelance. Realizzo siti web professionali, landing page e interfacce moderne ottimizzate SEO per aziende, startup e professionisti in tutta Italia.",

  keywords =
    "ux ui designer, ux designer, ui designer, web designer, react developer, front end developer, freelance web designer, freelance ux ui designer, realizzazione siti web, sviluppo siti web, web design pavia, web designer milano, ux designer italia, ui designer italia, seo, seo pavia, seo milano",

  url = "https://micheleragowebdesigner.com",

  image = "https://micheleragowebdesigner.com/og-image.jpg",

  type = "website",

  author = "Michele Rago",

  pageName = "Home",

}) {

  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",

    name: "Michele Rago",

    url,

    image,

    jobTitle: "UX/UI Designer",

    worksFor: {
      "@type": "Organization",
      name: "Freelance"
    },

    knowsAbout: [
      "UX Design",
      "UI Design",
      "React",
      "SEO",
      "Web Design",
      "Frontend Development"
    ],

    sameAs: [
      "https://www.linkedin.com/",
      "https://github.com/",
      "https://www.instagram.com/"
    ]
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",

    name: "Michele Rago",

    url,

    logo: image,

    image,

    description,

    address: {

      "@type": "PostalAddress",

      postalCode: "27100",

      addressLocality: "Pavia",

      addressRegion: "Lombardia",

      addressCountry: "IT"
    }
  };

  const serviceSchema = {

    "@context": "https://schema.org",

    "@type": "ProfessionalService",

    name: "Michele Rago UX/UI Designer",

    url,

    image,

    description,

    areaServed: [

      "Italia",

      "Pavia",

      "Milano"

    ],

    serviceType: [

      "UX Design",

      "UI Design",

      "Web Design",

      "React Development",

      "Landing Page",

      "SEO"

    ]
  };

  const websiteSchema = {

    "@context": "https://schema.org",

    "@type": "WebSite",

    name: "Michele Rago",

    url,

    description,

    inLanguage: "it",

    publisher: {

      "@type": "Person",

      name: "Michele Rago"
    }
  };

  const breadcrumbSchema = {

    "@context": "https://schema.org",

    "@type": "BreadcrumbList",

    itemListElement: [

      {

        "@type": "ListItem",

        position: 1,

        name: "Home",

        item: "https://micheleragowebdesigner.com"

      },

      {

        "@type": "ListItem",

        position: 2,

        name: pageName,

        item: url

      }

    ]
  };

  return (

    <Helmet>

      <html lang="it" />

      <title>{title}</title>

      <meta charSet="utf-8" />

      <meta
        name="viewport"
        content="width=device-width, initial-scale=1"
      />

      <meta name="description" content={description} />

      <meta name="keywords" content={keywords} />

      <meta name="author" content={author} />

      <meta
        name="robots"
        content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
      />

      <meta
        name="googlebot"
        content="index,follow,max-image-preview:large"
      />

      <meta
        name="bingbot"
        content="index,follow"
      />

      <meta
        name="theme-color"
        content="#0A0A0A"
      />

      <meta
        name="application-name"
        content="Michele Rago"
      />

      <meta
        name="apple-mobile-web-app-capable"
        content="yes"
      />

      <meta
        name="apple-mobile-web-app-status-bar-style"
        content="black"
      />

      <meta
        name="format-detection"
        content="telephone=no"
      />

      <meta name="geo.region" content="IT-LOM" />

      <meta name="geo.placename" content="Pavia" />

      <meta name="geo.position" content="45.184724;9.158206" />

      <meta name="ICBM" content="45.184724,9.158206" />

      <link rel="canonical" href={url} />

      <link rel="alternate" hrefLang="it" href={url} />

      <link rel="alternate" hrefLang="en" href={`${url}/en`} />

      <link rel="alternate" hrefLang="x-default" href={url} />

      <meta property="og:type" content={type} />

      <meta property="og:title" content={title} />

      <meta property="og:description" content={description} />

      <meta property="og:url" content={url} />

      <meta property="og:image" content={image} />

      <meta property="og:image:alt" content={title} />

      <meta property="og:locale" content="it_IT" />

      <meta property="og:site_name" content="Michele Rago" />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={title}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content={image}
      />

      <script type="application/ld+json">
        {JSON.stringify(personSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>

    </Helmet>

  );
};